<template>
  <div class="d-flex column-gap-1 align-center">
    <ClosdFildersIcon :document="file"/>
    <template v-if="file.numbering">
      <span data-locator="file-numbering">{{ `${file.numbering}` }}</span>
    </template>
    <div class="filderName" :class="{ 'filePdf clickable': isFilePdf }"
         data-locator="file-name"
         @click="onOpenDocument"
    >
      {{ file.basename || file.name }}
    </div>
    <div class="ml-auto">
      <app-badge v-if="isRedactedFile" style="text-transform: inherit;">
        {{ $t('project.documents.table.DocumentsTableItem.isRedacted') }}
      </app-badge>
      <app-badge v-if="file.version > 1" :class="{ 'ml-1': isRedactedFile }">
        {{ `v${file.version}` }}
      </app-badge>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ClosdFildersIcon from '@/common/filders/ClosdFildersIcon.vue'
import { getFileExtension, openFileViewer } from '@/common/utils/files'

export default {
  name: 'DocumentsTableItemFileName',
  components: { ClosdFildersIcon },
  props: {
    file: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('room', ['roomMnemo']),
    isFilePdf () {
      return getFileExtension(this.file) === 'pdf'
    },
    isRedactedFile () {
      return this.file.isRedacted
    },
  },
  methods: {
    onOpenDocument () {
      if (!this.isFilePdf) return
      openFileViewer(this.roomMnemo, this.file.id)
    },
  },
}
</script>

<style scoped>
  .filePdf:hover {
    text-decoration: underline;
  }
</style>
